(() => {
 'use strict';
 const normalize=value=>value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g,' ').trim();
 const params=new URLSearchParams(location.search);
 document.querySelectorAll('[data-yj-catalogue]').forEach(root=>{
  const search=root.querySelector('[data-yj-search]');
  const model=root.querySelector('[data-yj-model]');
  const type=root.querySelector('[data-yj-type]');
  const rows=Array.from(root.querySelectorAll('[data-yj-reference]'));
  const count=root.querySelector('[data-yj-result]');
  const empty=root.querySelector('[data-yj-empty]');
  const initialModel=model.value,initialType=type.value;
  if(initialModel){for(const option of Array.from(model.options))if(option.value!==initialModel)option.remove();model.disabled=true;}
  if(initialType){for(const option of Array.from(type.options))if(option.value!==initialType)option.remove();type.disabled=true;}
  if(!initialModel&&Array.from(model.options).some(o=>o.value===params.get('model')))model.value=params.get('model');
  if(!initialType&&Array.from(type.options).some(o=>o.value===params.get('type')))type.value=params.get('type');
  search.value=params.get('q')||'';
  const spanish=root.closest('[lang]').lang==='es';
  const size=12;let pageIndex=0;
  const pagination=document.createElement('nav');pagination.className='yjtr-pagination';pagination.setAttribute('aria-label',spanish?'Páginas de referencias':'Reference pages');
  const prev=document.createElement('button');prev.type='button';prev.textContent='\u2190';prev.title=spanish?'Página anterior':'Previous page';prev.setAttribute('aria-label',prev.title);
  const range=document.createElement('span');range.setAttribute('aria-live','polite');
  const next=document.createElement('button');next.type='button';next.textContent='\u2192';next.title=spanish?'Página siguiente':'Next page';next.setAttribute('aria-label',next.title);
  pagination.append(prev,range,next);count.after(pagination);
  function update(reset=true){
   if(reset)pageIndex=0;
   const terms=normalize(search.value).split(' ').filter(Boolean);
   const matched=rows.filter(row=>(!model.value||row.dataset.model===model.value)&&(!type.value||row.dataset.type===type.value)&&terms.every(term=>normalize(row.dataset.search).includes(term)));
   pageIndex=Math.min(pageIndex,Math.max(0,Math.ceil(matched.length/size)-1));
   const start=pageIndex*size;const visible=new Set(matched.slice(start,start+size));
   for(const row of rows)row.hidden=!visible.has(row);
   count.textContent=`${matched.length} ${spanish?'referencias encontradas':'references found'}`;
   empty.hidden=matched.length!==0;
   range.textContent=`${matched.length?start+1:0}-${Math.min(start+size,matched.length)} / ${matched.length}`;
   pagination.hidden=matched.length<=size;
   prev.disabled=pageIndex===0;next.disabled=start+size>=matched.length;
  }
  search.addEventListener('input',()=>update());model.addEventListener('change',()=>update());type.addEventListener('change',()=>update());
  prev.addEventListener('click',()=>{pageIndex--;update(false);});next.addEventListener('click',()=>{pageIndex++;update(false);});
  root.querySelector('[data-yj-reset]').addEventListener('click',()=>{search.value='';model.value=initialModel;type.value=initialType;update();search.focus();});
  update();
 });
})();
